const Monitoring = ({ fill, className }) => (
  <svg className={className} style={{ width: 18, height: 18 }} xmlns="http://www.w3.org/2000/svg"
       height="48px" viewBox="0 -960 960 960" width="48px" fill={fill || '#F4F5F9'}>
    <path
      d="M130-130v-62.92l45.38-45.39V-130H130Zm163.85 0v-222.92l45.38-45.39V-130h-45.38Zm163.46 0v-268.31l45.38 46.39V-130h-45.38Zm163.84 0v-221.92l45.39-45.39V-130h-45.39Zm163.47 0v-382.92L830-558.31V-130h-45.38ZM130-372.54v-63.84l270-268.77 160 160 270-270.62v64.23L560-480.92l-160-160-270 268.38Z" />
  </svg>
);

export default Monitoring;
